<template>
  <div class="content container__form-forum-thread">
    <p ref="text__forum-thread-title" class="text__topic">Create new comment</p>
    <ForumForm
      ref="forum-form__container"
      button-title="Comment"
      :reference-meta="referenceMeta"
      :provider="submit"
      @submit:invalid="onSubmitInvalid"
      @submit:success="onSubmitSuccess"
      @submit:error="onSubmitError"
      @cancel="onCancel"
    />
  </div>
</template>

<script>
import Forum from '@/models/Forum';
import { ForumThreads } from '../../../models/ForumThreads';
import ForumForm from '@/components/Forum/ForumForm.vue';

export default {
  components: {
    ForumForm
  },

  props: {
    forum: {
      type: Forum,
      required: true
    }
  },

  data() {
    return {
      referenceMeta: {
        ref: 'forum-threads',
        refId: null,
        field: 'images'
      }
    };
  },
  methods: {
    async submit(body) {
      const { content } = body;

      const { response } = await ForumThreads.api().createForumThread(this.forum.id, { content });

      const { data = {} } = response;

      return ForumThreads.find(data.id);
    },

    async onSubmitSuccess(insertedForumThread) {
      await ForumThreads.api().getForumThreadById(this.forum.id, insertedForumThread.id);

      await Forum.api().fetchById(this.forum.id);

      this.$emit('submit:success', insertedForumThread);

      this.$toast.success('Forum was updated successfully');
    },

    onSubmitError() {
      this.$toast.error('Cannot create new thread, please try again');
    },

    onSubmitInvalid() {
      this.$toast.error('Cannot create thread');
    },

    onCancel() {
      return this.$emit('cancel');
    }
  }
};
</script>

<style lang="scss">
.container__form-forum-thread {
  .text__topic {
    color: #3b3e66;
    font-size: 16px;
    font-weight: 700;
  }
}
</style>
